export default __webpack_public_path__ + "static/media/DNo.24-1.2a9ba157.jpg";